<template>
  <span v-if="resolved" class="transporte-badge" :class="size" :style="{ background: resolved.hex }">
    <!-- Próprio: carro -->
    <svg v-if="value === 'PROPRIO'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :width="iconSize" :height="iconSize" aria-hidden="true">
      <path fill="currentColor" d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
    </svg>
    <!-- Ônibus -->
    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :width="iconSize" :height="iconSize" aria-hidden="true">
      <path fill="currentColor" d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/>
    </svg>
    <span class="badge-label">{{ resolved.label }}</span>
  </span>
</template>

<script>
import { getTransporte } from '../lib/transportes'

export default {
  name: 'TransporteBadge',
  props: {
    value: { type: String, default: null },
    size: { type: String, default: 'normal' } // 'small' | 'normal' | 'large'
  },
  computed: {
    resolved() { return getTransporte(this.value) },
    iconSize() {
      if (this.size === 'large') return 28
      if (this.size === 'small') return 12
      return 16
    }
  }
}
</script>

<style scoped>
.transporte-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 14px;
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #fff;
}
.transporte-badge.small {
  padding: 2px 8px;
  font-size: 10px;
  gap: 4px;
}
.transporte-badge.large {
  padding: 10px 24px;
  font-size: var(--text-md);
  gap: var(--spacing-sm);
  border-radius: 20px;
}
.badge-label { line-height: 1; }
</style>
